export var ACTION;
(function (ACTION) {
    ACTION["TRIGGER_CTA"] = "TRIGGER_CTA";
    ACTION["TOGGLE_CTA"] = "TOGGLE_CTA";
    ACTION["DISABLE_CTA"] = "DISABLE_CTA";
    ACTION["ENABLE_CTA"] = "ENABLE_CTA";
    ACTION["AADHAR_NUMBER"] = "AADHAR_NUMBER";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["RESEND_OTP"] = "RESEND_OTP";
})(ACTION || (ACTION = {}));
